import { Component, Input } from '@angular/core';
import { User, REVOKED_TYPES } from '../../../models/user';

@Component({
  selector: 'app-profile-card-v2',
  templateUrl: './profile-card-v2.component.html',
  styleUrls: ['./profile-card-v2.component.scss'],
})
export class ProfileCardV2Component {
  @Input() user?: User;
  REVOKED_TYPES = REVOKED_TYPES;
}
